import React from 'react';

const UsersPermissionsIcon: React.FC = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 17"
      {...props}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.42857 0C2.51926 0 1.64719 0.358213 1.00421 0.995837C0.361224 1.63346 0 2.49826 0 3.4V5.1H24V3.4C24 2.49826 23.6388 1.63346 22.9958 0.995837C22.3528 0.358213 21.4807 0 20.5714 0H3.42857ZM0 13.6V6.8H24V13.6C24 14.5017 23.6388 15.3665 22.9958 16.0042C22.3528 16.6418 21.4807 17 20.5714 17H3.42857C2.51926 17 1.64719 16.6418 1.00421 16.0042C0.361224 15.3665 0 14.5017 0 13.6ZM16.2857 11.9C16.0584 11.9 15.8404 11.9896 15.6796 12.149C15.5189 12.3084 15.4286 12.5246 15.4286 12.75C15.4286 12.9754 15.5189 13.1916 15.6796 13.351C15.8404 13.5104 16.0584 13.6 16.2857 13.6H19.7143C19.9416 13.6 20.1596 13.5104 20.3204 13.351C20.4811 13.1916 20.5714 12.9754 20.5714 12.75C20.5714 12.5246 20.4811 12.3084 20.3204 12.149C20.1596 11.9896 19.9416 11.9 19.7143 11.9H16.2857Z" />
    </svg>
  );
};

export default UsersPermissionsIcon;
